<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-modal-select-dining-option"
      data-bs-toggle="modal"
      data-bs-target="#modalSelectDiningOption"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-modal-select-dining-option"
      data-bs-target="#modalSelectDiningOption"
      data-bs-dismiss="modal"
    ></button>
    <div
      class="modal fade"
      id="modalSelectDiningOption"
      tabindex="-1"
      aria-labelledby="modalSelectDiningOption"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <!-- KSK020: kiosk theme 2. MOO (isKiosk=false) keeps the markup below unchanged. -->
      <KskModalShell v-if="isKiosk" :width="680" :show-close="false">
        <div class="ksk-dining">
          <!-- Only when changing an existing choice; the first pick is mandatory. -->
          <button
            v-if="dismissible"
            type="button"
            class="ksk-dining__close"
            :aria-label="$t('kiosk.common.close')"
            data-bs-dismiss="modal"
          >
            <span class="material-icons-round">close</span>
          </button>
          <h2 id="modalSelectDiningOptionLabel" class="ksk-dining__title">{{ $t("kiosk.dining.title") }}</h2>
          <div class="ksk-dining__tiles">
            <button
              v-if="diningLocation == 0 || diningLocation == 2"
              type="button"
              class="ksk-dining__tile"
              v-bind="kskSlot('dining_tile')"
              :class="{ 'ksk-dining__tile--selected': highlighted == 2 }"
              :aria-pressed="highlighted == 2"
              @click="pick(2)"
            >
              <span v-if="highlighted == 2" class="ksk-dining__check material-icons-round">check</span>
              <span class="ksk-dining__icon material-icons-round">restaurant</span>
              <span class="ksk-dining__label">{{ $t("kiosk.common.dineIn") }}</span>
            </button>
            <button
              v-if="diningLocation == 0 || diningLocation == 1"
              type="button"
              class="ksk-dining__tile"
              v-bind="kskSlot('dining_tile')"
              :class="{ 'ksk-dining__tile--selected': highlighted == 1 }"
              :aria-pressed="highlighted == 1"
              @click="pick(1)"
            >
              <span v-if="highlighted == 1" class="ksk-dining__check material-icons-round">check</span>
              <span class="ksk-dining__icon material-icons-round">shopping_bag</span>
              <span class="ksk-dining__label">{{ $t("kiosk.common.takeAway") }}</span>
            </button>
          </div>
        </div>
      </KskModalShell>
      <div v-else class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">{{ $t("kiosk.dining.location") }}</div>
            <div class="d-flex mt-3" :class="diningLocation == 0 ? 'justify-content-between' : 'justify-content-center'">
              <div v-if="diningLocation == 0 || diningLocation == 2" class="text-center" @click="selectDiningOption(2)">
                <img
                  src="@/assets/dine_in.png"
                  alt=""
                  class="ms-2"
                  style="height: 80px; width: auto"
                />
                <div>{{ $t("kiosk.dining.dineInLower") }}</div>
              </div>
              <div v-if="diningLocation == 0 || diningLocation == 1" class="text-center" @click="selectDiningOption(1)">
                <img
                  src="@/assets/take_away.jpg"
                  alt=""
                  class="ms-2"
                  style="height: 80px; width: auto"
                />
                <div>{{ $t("kiosk.header.takeaway") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import KskModalShell from "./ui/KskModalShell.vue";
import { kskSlot } from "@/config/kioskColorSlots";

export default {
  name: "ModalSelectDiningOption",
  components: {
    KskModalShell,
  },
  data() {
    return {
      // KSK020: tile highlighted on tap (visual only; the choice is still
      // applied straight away by selectDiningOption, as before).
      picked: null,
    };
  },
  props: {
    diningLocation: {
      type: Number,
      default: 0,
    },
    selectDiningOption: {
      type: Function,
      default: () => {},
    },
    isKiosk: {
      type: Boolean,
      default: true,
    },
    // Kiosk: the current choice (1 = Takeaway, 2 = Dine in), pre-highlighted
    // when the picker is reopened to change it.
    selected: {
      type: Number,
      default: null,
    },
    // Kiosk: show a close button (changing an existing choice).
    dismissible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // The tile just tapped, else the current choice.
    highlighted() {
      return this.picked ?? this.selected;
    },
  },
  mounted() {
    $("#modalSelectDiningOption").on("show.bs.modal", () => {
      this.picked = null;
    });
  },
  beforeUnmount() {
    $("#modalSelectDiningOption").off("show.bs.modal");
  },
  methods: {
    kskSlot,
    pick(value) {
      this.picked = value;
      this.selectDiningOption(value);
    },
  },
};
</script>

<style scoped>
.modal {
  overflow-y: hidden !important;
}

.modal-dialog:not(.ksk-modal-dialog) {
  top: 50%;
  transform: translate(0, -50%) !important;
}

.modal-content {
  max-width: 270px;
  margin: 0 auto;
}

.btn-close-modal {
  border: 1px solid #d3d3d3;
  padding: 5px 30px;
  text-align: center;
  border-radius: 10px;
  background: none;
}

/* KSK020 — kiosk theme 2. Selected tile: brand border + tint, solid brand
   icon disc and a check badge. */
.ksk-dining {
  display: flex;
  flex-direction: column;
}
/* Centred title on its own line, under the close button (full width, so it
   fits on one line). */
.ksk-dining__title {
  margin: 0 0 var(--ksk-space-4);
  text-align: center;
  font-family: var(--ksk-font);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ksk-text);
}
.ksk-dining__close {
  align-self: flex-end;
  width: 56px;
  height: 56px;
  margin: -16px -16px 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: var(--ksk-surface-muted);
  color: var(--ksk-text);
  cursor: pointer;
  transition: transform 80ms ease-out;
}
.ksk-dining__close .material-icons-round {
  font-size: 28px;
}
.ksk-dining__close:active {
  transform: scale(0.97);
}
.ksk-dining__tiles {
  display: flex;
  justify-content: center;
  gap: var(--ksk-space-2);
}
.ksk-dining__tile {
  position: relative;
  flex: 1 1 0;
  max-width: 320px;
  height: 240px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--ksk-space-2);
  padding: var(--ksk-space-3);
  border: 2px solid var(--ksk-border);
  border-radius: var(--ksk-radius-card);
  background: var(--ksk-surface);
  /* KSK063: dining_tile colour slot (outline = selected ring, font = label,
     accent = icon + tick + tint); theme values otherwise. */
  color: var(--ksk-slot-font, var(--ksk-text));
  font-family: var(--ksk-font);
  cursor: pointer;
  transition: transform 80ms ease-out, border-color 120ms ease-out, background-color 120ms ease-out;
  -webkit-tap-highlight-color: transparent;
}
.ksk-dining__tile:active {
  transform: scale(0.98);
}
.ksk-dining__tile--selected {
  border-color: var(--ksk-slot-outline, var(--ksk-primary));
  background: color-mix(in srgb, var(--ksk-slot-accent, var(--ksk-primary)) 12%, #ffffff);
}
.ksk-dining__check {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--ksk-slot-accent, var(--ksk-primary));
  color: var(--ksk-on-primary);
  font-size: 26px;
}
.ksk-dining__icon {
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--ksk-surface-muted);
  color: var(--ksk-slot-accent, var(--ksk-primary));
  font-size: 52px;
  transition: background-color 120ms ease-out, color 120ms ease-out;
}
.ksk-dining__tile--selected .ksk-dining__icon {
  background: var(--ksk-slot-accent, var(--ksk-primary));
  color: var(--ksk-on-primary);
}
.ksk-dining__label {
  font-size: 28px;
  line-height: 36px;
  font-weight: 700;
}
</style>
